import { makeStyles } from 'tss-react/mui'

export default makeStyles()(() => ({
  // TODO: eslint thinks this actually used class definition is unused
  // eslint-disable-next-line tss-unused-classes/unused-classes
  textField: {
    '.MuiInputBase-input': {
      textAlign: 'right',
    },
  },
}))
